import { render, staticRenderFns } from "./topicDetail.vue?vue&type=template&id=879d0b88&"
import script from "./topicDetail.vue?vue&type=script&lang=js&"
export * from "./topicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports